(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6081],{

/***/ 26102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83157);
/* harmony import */ var _styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31555);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54076);










const StudiesFAQ = ({ faqdata  })=>{
    const sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const settings = {
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 3,
        rows: 3,
        slidesPerRow: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 3,
                    arrows: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 3,
                    dotsClass: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sliderDots),
                    dots: true
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().studyquas),
            style: {
                backgroundColor: faqdata?.sectionBgColor || "#EFEFFA"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().heading),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: faqdata?.sectionTitle
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().popularCourseslider),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    ...settings,
                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().slider),
                                    ref: sliderRef,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            children: faqdata?.questions?.length > 0 && faqdata?.questions?.map((faqsdata)=>{
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                    xl: 6,
                                                    lg: 6,
                                                    md: 6,
                                                    sm: 12,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                        defaultActiveKey: "0",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
                                                            className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().stuAccordion),
                                                            eventKey: "1",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Header */ .Z.Header, {
                                                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accoHead),
                                                                    children: faqsdata?.question
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Body */ .Z.Body, {
                                                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accorBody),
                                                                    children: faqsdata?.answer
                                                                })
                                                            ]
                                                        })
                                                    })
                                                });
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (StudiesFAQ);


/***/ }),

/***/ 70710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LazyReveal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
"use client";


const DefaultShimmer = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "animate-pulse bg-gray-300 h-6 w-full rounded-lg"
    });
function LazyReveal({ children , shimmer , rootMargin ="0px" , threshold =0.1 , className , onVisible , id , style  }) {
    const { 0: visible , 1: setVisible  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const observerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!wrapperRef.current) return;
        observerRef.current = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry.isIntersecting) {
                setVisible(true);
                onVisible && onVisible();
                observerRef.current?.disconnect();
            }
        }, {
            rootMargin,
            threshold
        });
        observerRef.current.observe(wrapperRef.current);
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, [
        rootMargin,
        threshold
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: wrapperRef,
        className: className,
        id: id,
        style: style,
        children: visible ? children : shimmer || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DefaultShimmer, {})
    });
}


/***/ }),

/***/ 96138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78182);
/* harmony import */ var _styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28564);
/* harmony import */ var _styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45992);








const ManagersSlider = ({ data  })=>{
    const settings = {
        dotsClass: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().sliderDots),
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "managers-slidr",
        className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().regionaManagerSlider),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            ...settings,
            className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().slider),
            children: data.map((card)=>{
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().sliderCardDiv),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().card),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Body */ .Z.Body, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().regiManagerImg),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        src: card?.imageUrl,
                                        layout: "responsive",
                                        height: 250,
                                        width: 250,
                                        className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().regiManagerImg),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Title */ .Z.Title, {
                                    className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
                                    children: card?.name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Title */ .Z.Title, {
                                    className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().designation),
                                    children: card?.designation
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Subtitle */ .Z.Subtitle, {
                                    className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().subtitle),
                                    children: card?.location
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Text */ .Z.Text, {
                                    className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
                                    children: card?.mobile
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Text */ .Z.Text, {
                                    className: (_styles_contcatus_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
                                    children: card?.email
                                })
                            ]
                        })
                    })
                });
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ManagersSlider);


/***/ }),

/***/ 79782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21174);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98196);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32866);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70710);










const AccomplishSection = ({ eventData  })=>{
    const { zipmeLink , generateLink  } = (0,_hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().accomplishSection),
        style: {
            background: `linear-gradient(0deg, ${eventData?.accomplishSection?.sectionBgColorBottom || "#EEF2FB"} 50%, ${eventData?.accomplishSection?.sectionBgColorTop || "#ffffff"} 0)`
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().studentFooter),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().session),
                            style: {
                                backgroundColor: `${eventData?.accomplishSection?.sectionBgColor}`
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        style: {
                                            color: eventData?.titleTextColor || eventData?.accomplishSection?.sectionTitleColor || "#fff"
                                        },
                                        children: eventData?.accomplishSection?.sectionTitle
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().anchor),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            onClick: ()=>{
                                                !eventData?.meta?.jotforms[0]?.jotformid && generateLink(eventData?.externalLink);
                                            },
                                            className: `btn btn-primary   ${eventData?.meta?.jotforms[0]?.jotformid ? ` ${(0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isFrappeOrJotFormClass */ .gd)(eventData?.meta?.jotforms[0]?.jotformid)}` : ""}`,
                                            children: eventData.accomplishSection?.button?.label || "Register Now"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                                            dangerouslySetInnerHTML: {
                                                __html: `window.lintrk('track', { conversion_id: 6870956 });`
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AccomplishSection);


/***/ }),

/***/ 54455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21174);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98196);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32866);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70710);










const GrabChanceSection = ({ eventData  })=>{
    const { zipmeLink , generateLink  } = (0,_hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        style: {
            background: `linear-gradient(0deg, ${eventData?.grabChanceSection?.sectionBgColorBottom || "#F7F8F7"} 50%, ${eventData?.grabChanceSection?.sectionBgColorTop || "#DBD9FC"} 0)`
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().studentFooter),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().session),
                            style: {
                                backgroundColor: `${eventData?.grabChanceSection?.sectionBgColor}`
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        style: {
                                            color: eventData?.titleTextColor || eventData?.grabChanceSection?.sectionTitleColor || "#fff"
                                        },
                                        children: eventData?.grabChanceSection?.sectionTitle
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().anchor),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            onClick: ()=>{
                                                !eventData?.meta?.jotforms[0]?.jotformid && generateLink(eventData?.externalLink);
                                            },
                                            className: `btn btn-primary   ${eventData?.meta?.jotforms[0]?.jotformid ? ` ${(0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isFrappeOrJotFormClass */ .gd)(eventData?.meta?.jotforms[0]?.jotformid)}` : ""}`,
                                            children: eventData.grabChanceSection?.button?.label || "Register Now"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                                            dangerouslySetInnerHTML: {
                                                __html: `window.lintrk('track', { conversion_id: 6870956 });`
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GrabChanceSection);


/***/ }),

/***/ 51416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_FranchiseeModel_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79534);
/* harmony import */ var _styles_FranchiseeModel_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_FranchiseeModel_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31555);
/* harmony import */ var react_bootstrap_Table__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75147);







const FranchiseeModel = ({ franchiseeModelData  })=>{
    const footerModel = franchiseeModelData.footerModel;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_FranchiseeModel_module_scss__WEBPACK_IMPORTED_MODULE_2___default().franchiseeModel),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: franchiseeModelData?.sectionTitle
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Table__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                        className: (_styles_FranchiseeModel_module_scss__WEBPACK_IMPORTED_MODULE_2___default().headtr),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                children: "Requirements"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                colSpan: 2,
                                                children: "Details"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                                    className: (_styles_FranchiseeModel_module_scss__WEBPACK_IMPORTED_MODULE_2___default().customtr),
                                    children: franchiseeModelData?.franchiseeModel?.length > 0 && franchiseeModelData?.franchiseeModel.map((data)=>{
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                                id: data.id,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                        children: data.particular
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                        children: data.values
                                                    })
                                                ]
                                            })
                                        });
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                        className: (_styles_FranchiseeModel_module_scss__WEBPACK_IMPORTED_MODULE_2___default().footertr),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                children: footerModel.particular || ""
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("th", {
                                                colSpan: 2,
                                                children: [
                                                    " ",
                                                    footerModel.values || "",
                                                    " "
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FranchiseeModel);


/***/ }),

/***/ 91582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ StudyAbroad_FranchiseeComponent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./styles/pstlandingpage.module.scss
var pstlandingpage_module = __webpack_require__(42547);
var pstlandingpage_module_default = /*#__PURE__*/__webpack_require__.n(pstlandingpage_module);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
;// CONCATENATED MODULE: ./components/PST/Associating.tsx








const AssociatingWithKc = ({ associatingdata , title , subtitle , bgcolor  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (pstlandingpage_module_default()).association,
        style: {
            backgroundColor: bgcolor || "#FFF1EF"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    className: "text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: "mb-4",
                                children: subtitle
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: associatingdata.map((details)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (pstlandingpage_module_default()).mainCard,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                className: (pstlandingpage_module_default()).custCard,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xl: 4,
                                            md: 4,
                                            sm: 4,
                                            xs: 12,
                                            className: (pstlandingpage_module_default()).imgDiv,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: details?.sectionImageUrl || "/images/partners/dummy.svg",
                                                width: 300,
                                                height: 250,
                                                alt: "dummy"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xl: 8,
                                            md: 8,
                                            sm: 8,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                                className: (pstlandingpage_module_default()).cardBody,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                        className: "text-center",
                                                        children: details?.sectionTitle
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (pstlandingpage_module_default()).mainDiv,
                                                        children: details?.points?.length > 0 && details?.points?.map((text)=>{
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (pstlandingpage_module_default()).div,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                            xl: 3,
                                                                            md: 3,
                                                                            sm: 4,
                                                                            xs: 12,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                                                                children: [
                                                                                    text?.label,
                                                                                    " "
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                                                            xl: 9,
                                                                            md: 9,
                                                                            sm: 8,
                                                                            xs: 12,
                                                                            children: [
                                                                                " ",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: text?.value
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            });
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        });
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Associating = (AssociatingWithKc);

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
;// CONCATENATED MODULE: ./components/PST/Steps.tsx










const ThreeSteps = ({ data , bgcolor  })=>{
    const settings = {
        dotsClass: (pstlandingpage_module_default()).sliderDots,
        dots: false,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 0,
        autoplay: true,
        speed: 500,
        infinite: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (pstlandingpage_module_default()).steps,
        style: {
            backgroundColor: bgcolor || "#ffff"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    className: "text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: data?.sectionTitle
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                        ...settings,
                        children: data?.attendCard?.length > 0 && data?.attendCard?.map((points)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (pstlandingpage_module_default()).points,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                    className: (pstlandingpage_module_default()).mainbox,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (pstlandingpage_module_default()).boximg,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: points?.cardImageUrl || "/images/testprep/1.png",
                                                    height: 167,
                                                    width: 167,
                                                    alt: "testprep"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (pstlandingpage_module_default()).content,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: points?.otherTitle
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: points?.cardTitle
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: points?.cardDetail
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            });
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Steps = (ThreeSteps);

;// CONCATENATED MODULE: ./components/PST/Universities.tsx









const GloballyUniversities = ({ data  })=>{
    const sliderRef = (0,react.useRef)(null);
    const settings = {
        dotsClass: (pstlandingpage_module_default()).sliderDots,
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 3,
        slidesPerRow: 4,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    rows: 2,
                    slidesPerRow: 2
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (pstlandingpage_module_default()).uni,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    className: "text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: data?.sectionTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: "mb-4",
                                children: data?.sectionDescription
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (pstlandingpage_module_default()).sliderdiv,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                ...settings,
                                className: (pstlandingpage_module_default()).slider,
                                ref: sliderRef,
                                children: data?.universityImages?.length > 0 ? data?.universityImages.map((university)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (pstlandingpage_module_default()).logo,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: university?.imageUrl || "/images/uni-logo/manitoba.svg",
                                                alt: university?.alt,
                                                width: 321,
                                                height: 132,
                                                className: (pstlandingpage_module_default()).img
                                            })
                                        })
                                    });
                                }) : "No Universities"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (pstlandingpage_module_default()).arrowsClass,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (pstlandingpage_module_default()).btcircle,
                                        onClick: ()=>sliderRef?.current?.slickPrev(),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: "/new-images/left-arrow.svg",
                                            height: 17,
                                            width: 10,
                                            alt: "left-arrow"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (pstlandingpage_module_default()).btcircle,
                                        onClick: ()=>sliderRef?.current?.slickNext(),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: "/new-images/right-arrow.svg",
                                            height: 17,
                                            width: 10,
                                            alt: "right-arrow"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Universities = (GloballyUniversities);

// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./hooks/useZipmeLink.tsx
var useZipmeLink = __webpack_require__(98196);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
;// CONCATENATED MODULE: ./components/PST/Capabilities.tsx










const CapabilitiesCourseFinder = ({ eventData  })=>{
    const courseFinder = eventData.courseFinder || eventData.coursefinder;
    const { zipmeLink , generateLink  } = (0,useZipmeLink/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (pstlandingpage_module_default()).capabilityBg,
            style: {
                backgroundColor: courseFinder?.sectionBgColor || "#FEF7EE"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        className: "text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (pstlandingpage_module_default()).heading,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: eventData.techCapabilityTitle || "Technological Capabilities"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: eventData.techCapabilitySubTitle || "An all-in-one platform that supports every step of the recruitment process, to make faster and smarter."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        className: (pstlandingpage_module_default()).imgRow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                xl: 6,
                                lg: 6,
                                md: 6,
                                sm: 6,
                                xs: 12,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (pstlandingpage_module_default()).content,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: courseFinder?.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: courseFinder?.description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: courseFinder?.points?.length > 0 && courseFinder.points.map((text)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (pstlandingpage_module_default()).subcontent,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        children: text.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: text.description
                                                    })
                                                ]
                                            });
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            onClick: ()=>{
                                                !eventData.meta?.jotforms[0]?.jotformid && generateLink(eventData.externalLink);
                                            },
                                            className: `${(0,helpers/* isFrappeOrJotFormClass */.gd)(eventData.meta?.jotforms[0]?.jotformid)}`,
                                            children: courseFinder?.button?.label || "Enquire Now"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xl: 6,
                                lg: 6,
                                md: 6,
                                sm: 6,
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (pstlandingpage_module_default()).imgDiv,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: courseFinder?.imagePath || "/images/partners/partner1.svg",
                                        alt: courseFinder?.imageAltTag,
                                        height: 480,
                                        width: 600
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Capabilities = (CapabilitiesCourseFinder);

// EXTERNAL MODULE: ./components/OverseasEdutionFair/AccomplishSection.tsx
var AccomplishSection = __webpack_require__(79782);
// EXTERNAL MODULE: ./components/OverseasEdutionFair/eduFairStudTestimonials.tsx
var eduFairStudTestimonials = __webpack_require__(91071);
// EXTERNAL MODULE: ./components/AdmissionsDay/StudiesFAQ.tsx
var StudiesFAQ = __webpack_require__(26102);
// EXTERNAL MODULE: ./components/OverseasEdutionFair/GrabChanceSection.tsx
var GrabChanceSection = __webpack_require__(54455);
;// CONCATENATED MODULE: ./components/PST/Footer.tsx










const PartnerFooter = ({ data , jotformId , externalLink  })=>{
    const { zipmeLink , generateLink  } = (0,useZipmeLink/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (pstlandingpage_module_default()).footer,
        style: {
            backgroundColor: data?.sectionTopBgColor || "#F2F2F2"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    className: "text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (pstlandingpage_module_default()).footerlogo,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: "/",
                                target: "_blank",
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: "/images/educationfair/kc_logo.svg",
                                        width: 180,
                                        height: 45,
                                        className: (pstlandingpage_module_default()).navLogo,
                                        alt: "kclogo"
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: data?.footerTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    onClick: ()=>{
                                        !jotformId && generateLink(externalLink);
                                    },
                                    className: `d-none d-sm-block mx-auto ${(0,helpers/* isFrappeOrJotFormClass */.gd)(jotformId)}`,
                                    children: "Enquire Now"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Footer = (PartnerFooter);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Nav.js + 3 modules
var Nav = __webpack_require__(80957);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 7 modules
var react_select_esm = __webpack_require__(15707);
;// CONCATENATED MODULE: ./components/PST/PartnerBanner.tsx













const customStyles = {
    option: (provided, state)=>({
            ...provided,
            color: state.isFocused && "#6c48f0",
            background: "none",
            "&:hover": {
                backgroundColor: "lightgray",
                borderRadius: "20px"
            }
        })
};
const localeOptions = [
    {
        label: "Vietnamese",
        value: "Vietnamese"
    },
    {
        label: "English",
        value: "English"
    }
];
const PartnerBannerSection = ({ data , jotforms , externalLink  })=>{
    const router = (0,next_router.useRouter)();
    const { zipmeLink , generateLink  } = (0,useZipmeLink/* default */.Z)();
    const handleLocaleChange = (selectedOption)=>{
        selectedOption.value === "Vietnamese" ? router.push(router.asPath, router.asPath, {
            locale: "vi-VN"
        }) : router.push(router.asPath, router.asPath, {
            locale: "en"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (pstlandingpage_module_default()).banner,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                (router.asPath.includes("recruiter/") || router.asPath.includes("franchisee/") || router.asPath.includes("/partners/study-abroad-recruiter") && !router.asPath.includes("/partners/study-abroad-recruiter-in")) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (pstlandingpage_module_default()).nav,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: data?.kcImageUrl || "/images/educationfair/kc_logo.svg",
                                        width: 180,
                                        height: 45,
                                        alt: "kc_logo"
                                    })
                                })
                            }),
                            router.asPath.includes("vietnam") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                className: (pstlandingpage_module_default()).localeButton,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
                                    options: localeOptions,
                                    value: router.locale === "vi-VN" ? localeOptions[0] : localeOptions[1],
                                    className: (pstlandingpage_module_default()).selectClass,
                                    classNamePrefix: "myLocaleSelect",
                                    components: {
                                        IndicatorSeparator: ()=>null
                                    },
                                    styles: customStyles,
                                    onChange: handleLocaleChange
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (pstlandingpage_module_default()).maincontent,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "d-block d-sm-none text-center mb-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xl: 6,
                                    lg: 6,
                                    md: 12,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (pstlandingpage_module_default()).bannerStudDiv,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (pstlandingpage_module_default()).bg,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: data?.mainImageUrl || "/images/testprep/IELTS.png",
                                                width: "350",
                                                height: "350",
                                                className: (pstlandingpage_module_default()).studImg,
                                                alt: "pst"
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xl: 6,
                                lg: 6,
                                md: 12,
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (pstlandingpage_module_default()).fairdetails,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (pstlandingpage_module_default()).heading,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    children: data?.mainTitle
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        " ",
                                                        data?.subTitle
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    className: (pstlandingpage_module_default()).ulli,
                                                    children: data?.points?.length > 0 && data?.points?.map((point)=>{
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                color: data?.pointsColor || "#fff"
                                                            },
                                                            className: (pstlandingpage_module_default()).liItem,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                    src: point?.imageUrl || "/images/starthd.png",
                                                                    width: 20,
                                                                    height: 20,
                                                                    className: (pstlandingpage_module_default()).img,
                                                                    alt: point.title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: point.title
                                                                })
                                                            ]
                                                        }, point.id);
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (pstlandingpage_module_default()).regBtn,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    onClick: ()=>{
                                                        !jotforms[0]?.jotformid && generateLink(externalLink);
                                                    },
                                                    className: `${(pstlandingpage_module_default()).btnReg}${jotforms[0]?.jotformid ? ` ${(0,helpers/* isFrappeOrJotFormClass */.gd)(jotforms[0]?.jotformid)}` : ""}`,
                                                    children: data.button?.[0]?.label || "Enquire Now"
                                                }),
                                                jotforms.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    className: `${(pstlandingpage_module_default()).enq} ${(0,helpers/* isFrappeOrJotFormClass */.gd)(jotforms[1]?.jotformid)}`,
                                                    children: data.button?.[1]?.label || "Register Now"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xl: 6,
                                lg: 6,
                                md: 12,
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "d-none d-sm-block text-center mb-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (pstlandingpage_module_default()).bannerStudDiv,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (pstlandingpage_module_default()).bg,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: data?.mainImageUrl || "/images/testprep/IELTS.png",
                                                width: 450,
                                                height: 450,
                                                className: (pstlandingpage_module_default()).studImg,
                                                alt: "location.png"
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var PartnerBanner = (PartnerBannerSection);

;// CONCATENATED MODULE: ./components/PST/WhyKc.tsx







const WhyKC = ({ whykcdata  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (pstlandingpage_module_default()).WhyKc,
        style: {
            backgroundColor: whykcdata?.sectionBgColor || "#fff"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: whykcdata?.sectionTitle
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: whykcdata?.whyKc?.length > 0 && whykcdata?.whyKc?.map((whydata)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xl: 4,
                            md: 4,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-center mb-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (pstlandingpage_module_default()).img,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: whydata?.imagePath || "/images/locationicon.png",
                                            alt: whydata?.ImageAltTag,
                                            width: 130,
                                            height: 100
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                        children: whydata?.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: whydata?.description
                                    })
                                ]
                            })
                        });
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var WhyKc = (WhyKC);

;// CONCATENATED MODULE: ./components/PST/RightBussinessDecision.tsx










const RightBussinessDecisionKc = ({ data , jotformId , externalLink  })=>{
    const { zipmeLink , generateLink  } = (0,useZipmeLink/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (pstlandingpage_module_default()).bussiness,
        style: {
            backgroundColor: data?.sectionBgColor || "#F2F8FF"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: data.sectionTitle
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xl: 6,
                            md: 6,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: data?.sectionImageUrl || "/images/partners/partner1.svg",
                                    height: 430,
                                    width: 500,
                                    alt: ""
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            xl: 6,
                            md: 6,
                            xs: 12,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-0",
                                    children: data?.sectionPoints.map((points)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                points,
                                                " "
                                            ]
                                        });
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                children: data?.otherPoints?.length > 0 && data?.otherPoints?.map((points)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (pstlandingpage_module_default()).liItem,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: points?.imageUrl || "/images/starthd.png",
                                                                width: 20,
                                                                height: 20,
                                                                className: (pstlandingpage_module_default()).img,
                                                                alt: points.title
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: points.title
                                                            })
                                                        ]
                                                    }, points.id);
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        onClick: ()=>{
                                            !jotformId && generateLink(externalLink);
                                        },
                                        className: `${(pstlandingpage_module_default()).reg}${jotformId ? ` ${(0,helpers/* isFrappeOrJotFormClass */.gd)(jotformId)}` : ""}`,
                                        children: data.button?.label || "Let’s get Started"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var RightBussinessDecision = (RightBussinessDecisionKc);

;// CONCATENATED MODULE: ./components/PST/ElanLoan.tsx










const ElanLoan = ({ data , jotformId , bgColor , externalLink  })=>{
    const { zipmeLink , generateLink  } = (0,useZipmeLink/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (pstlandingpage_module_default()).capabilityBg,
            style: {
                backgroundColor: bgColor || "#fffff"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xl: 6,
                            lg: 6,
                            md: 6,
                            sm: 6,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: data?.imagePath || "/images/partners/partner1.svg",
                                    alt: data?.imageAltTag,
                                    height: 430,
                                    width: 480
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            xl: 6,
                            lg: 6,
                            md: 6,
                            sm: 6,
                            xs: 12,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: data?.title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (pstlandingpage_module_default()).content,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: data?.description
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: data?.points?.length > 0 && data?.points?.map((text)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (pstlandingpage_module_default()).subcontent,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: text.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: text.description
                                                })
                                            ]
                                        });
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        onClick: ()=>{
                                            !jotformId && generateLink(externalLink);
                                        },
                                        className: `${(0,helpers/* isFrappeOrJotFormClass */.gd)(jotformId)}`,
                                        children: data.button?.label || "Enquire Now"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var PST_ElanLoan = (ElanLoan);

;// CONCATENATED MODULE: ./components/PST/RecruitmentPartner.tsx











const RecruitmentPartner = (props)=>{
    const { eventData  } = props;
    const sliderRef = (0,react.useRef)(null);
    const recruitmentPartnerData = eventData.recruitmentPartner;
    const buttonLabel = "Enquire Now";
    const { zipmeLink , generateLink  } = (0,useZipmeLink/* default */.Z)();
    var settingsCountrySlider = {
        dotsClass: (pstlandingpage_module_default()).sliderDots,
        dots: false,
        infinite: true,
        speed: 2000,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (pstlandingpage_module_default()).elanLoansComp,
            style: {
                backgroundColor: recruitmentPartnerData?.sectionBgColor || "#fffff"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                md: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (pstlandingpage_module_default()).elanContent,
                                    children: recruitmentPartnerData?.recruitmentPartnerTitle
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                md: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (pstlandingpage_module_default()).elanSubheading,
                                    children: recruitmentPartnerData?.recruitmentPartnerSubTitle
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (pstlandingpage_module_default()).imageDiv,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                    ...settingsCountrySlider,
                                    ref: sliderRef,
                                    className: (pstlandingpage_module_default()).slider,
                                    children: recruitmentPartnerData?.recruitmentPartners?.length > 0 && recruitmentPartnerData.recruitmentPartners.map((img, index)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (pstlandingpage_module_default()).logo,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (pstlandingpage_module_default()).imageDiv,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: img?.image?.url,
                                                            alt: img?.image?.alternativeText,
                                                            width: 180,
                                                            height: 120,
                                                            className: (pstlandingpage_module_default()).image
                                                        })
                                                    }, index)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: img?.name
                                                })
                                            ]
                                        });
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (pstlandingpage_module_default()).button,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        id: "enquirebtn",
                                        variant: "primary",
                                        size: "lg",
                                        onClick: ()=>{
                                            generateLink(eventData?.externalLink);
                                        },
                                        className: `${(pstlandingpage_module_default()).btnReg}${eventData.meta?.jotforms[0] ? ` ${(0,helpers/* isFrappeOrJotFormClass */.gd)(eventData.meta?.jotforms[0].jotformid)}` : ""}`,
                                        children: recruitmentPartnerData.button?.label || buttonLabel
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var PST_RecruitmentPartner = (RecruitmentPartner);

// EXTERNAL MODULE: ./components/OverseasEdutionFair/eduFairFooter.tsx
var eduFairFooter = __webpack_require__(74050);
// EXTERNAL MODULE: ./components/PST/FranchiseeModel.tsx
var FranchiseeModel = __webpack_require__(51416);
// EXTERNAL MODULE: ./styles/contcatus.module.scss
var contcatus_module = __webpack_require__(28564);
var contcatus_module_default = /*#__PURE__*/__webpack_require__.n(contcatus_module);
// EXTERNAL MODULE: ./components/ManagerCards.tsx
var ManagerCards = __webpack_require__(96138);
;// CONCATENATED MODULE: ./components/StudyAbroad/CountryTeam.tsx





const CountryTeam = ({ countryTeamData  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "country-team",
        className: `${(contcatus_module_default()).officeCountries}`,
        style: {
            backgroundColor: "#FFE7C9"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                countryTeamData?.regionalManagers && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "reg-manag",
                    className: (contcatus_module_default()).regionalManagers,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                        children: [
                                            "Connect with our ",
                                            countryTeamData?.countryName,
                                            " Team"
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                id: "regional-managers",
                                children: countryTeamData.regionalManagers.managerCard?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagerCards/* default */.Z, {
                                    data: countryTeamData.regionalManagers.managerCard
                                })
                            })
                        ]
                    })
                }),
                countryTeamData?.countrySalesManagers && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (contcatus_module_default()).regionalSalesManagers,
                    style: {
                        backgroundColor: "#FFE7C9"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: countryTeamData.countrySalesManagers.title
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: countryTeamData.countrySalesManagers.managerCard?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagerCards/* default */.Z, {
                                    data: countryTeamData.countrySalesManagers.managerCard
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var StudyAbroad_CountryTeam = (CountryTeam);

;// CONCATENATED MODULE: ./components/StudyAbroad/FranchiseeComponent.tsx






















const FranchiseeComponent = ({ eventData , countryTeamData  })=>{
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--event-bgcolor", eventData?.bannerSection?.sectionBgColor || "#6C48F0");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            eventData && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...eventData.meta
            }),
            (eventData.bannerSection || eventData.banerSection) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerBanner, {
                    data: eventData.bannerSection || eventData.banerSection,
                    jotforms: eventData?.meta?.jotforms,
                    externalLink: eventData?.externalLink
                })
            }),
            eventData?.whyKcSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyKc, {
                    whykcdata: eventData?.whyKcSection
                })
            }),
            eventData?.franchiseeModelSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(FranchiseeModel/* default */.Z, {
                franchiseeModelData: eventData?.franchiseeModelSection
            }),
            eventData?.whyChooseKc && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightBussinessDecision, {
                    data: eventData.whyChooseKc,
                    jotformId: eventData?.meta?.jotforms[0]?.jotformid,
                    externalLink: eventData?.externalLink
                })
            }),
            eventData?.benefitsSectionCards && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Associating, {
                    associatingdata: eventData?.benefitsSectionCards,
                    title: eventData?.benefitsSectionTitle,
                    subtitle: eventData?.benefitsSectionSubTitle,
                    bgcolor: eventData?.benefitsSectionBgColor
                })
            }),
            eventData?.recruitmentPartner && /*#__PURE__*/ (0,jsx_runtime.jsx)(PST_RecruitmentPartner, {
                eventData: eventData
            }),
            eventData?.tieUpsSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Universities, {
                    data: eventData?.tieUpsSection
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GrabChanceSection/* default */.Z, {
                eventData: eventData
            }),
            (eventData?.courseFinder || eventData?.coursefinder) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Capabilities, {
                    eventData: eventData
                })
            }),
            (eventData?.elanLoans || eventData?.elanloans) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PST_ElanLoan, {
                    data: eventData.elanLoans || eventData.elanloans,
                    jotformId: eventData?.meta?.jotforms[0]?.jotformid,
                    externalLink: eventData?.externalLink,
                    bgColor: eventData.elanLoans?.sectionBgColor || eventData.elanloans?.sectionBgColor
                })
            }),
            eventData?.easyStepsSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Steps, {
                    data: eventData?.easyStepsSection,
                    bgcolor: eventData?.easyStepsSection?.sectionBgColor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccomplishSection/* default */.Z, {
                eventData: eventData
            }),
            eventData?.studentsSaySection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairStudTestimonials["default"], {
                    data: eventData?.studentsSaySection
                })
            }),
            countryTeamData?.length > 0 && (countryTeamData[0]?.countrySalesManagers?.managerCard?.length > 0 || countryTeamData[0].regionalManagers?.managerCard?.length > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StudyAbroad_CountryTeam, {
                    countryTeamData: countryTeamData[0]
                })
            }),
            eventData?.faqSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StudiesFAQ["default"], {
                    faqdata: eventData?.faqSection
                })
            }),
            eventData?.footerSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: router.asPath.includes("recruiter/") && !router.asPath.includes("become-overseas-education-recruiter") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairFooter/* default */.Z, {
                        data: eventData?.footerSection,
                        jotformId: eventData?.meta?.jotforms[0]?.jotformid,
                        externalLink: eventData?.externalLink
                    })
                }) : (router.asPath.includes("recruiter/") || router.asPath.includes("franchisee/") || router.asPath.includes("/partners/study-abroad-recruiter")) && !router.asPath.includes("/partners/study-abroad-recruiter-in") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                        data: eventData?.footerSection,
                        jotformId: eventData?.meta?.jotforms[0]?.jotformid,
                        externalLink: eventData?.externalLink
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var StudyAbroad_FranchiseeComponent = (FranchiseeComponent);


/***/ }),

/***/ 79534:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"franchiseeModel":"FranchiseeModel_franchiseeModel__teyC6","headtr":"FranchiseeModel_headtr__HC1Zl","headsmalltr":"FranchiseeModel_headsmalltr__7laOY","customtr":"FranchiseeModel_customtr__d_6CY","footertr":"FranchiseeModel_footertr__Sjq1D"};

/***/ }),

/***/ 28564:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contcatus_section":"contcatus_contcatus_section__KPipa","breadcrum":"contcatus_breadcrum__iZBVT","active":"contcatus_active__Dbjmi","enquirebtn":"contcatus_enquirebtn__2flvt","heading":"contcatus_heading__XBO8r","buttongp":"contcatus_buttongp__k6jZa","kcbtn":"contcatus_kcbtn__Shytg","centered":"contcatus_centered__nFqbD","our_offices":"contcatus_our_offices__m6543","offices":"contcatus_offices__JD9Dq","inputBox":"contcatus_inputBox__JGUIu","inputBtn":"contcatus_inputBtn__ZhubC","activeCountry":"contcatus_activeCountry__bY51u","country_flags":"contcatus_country_flags__obGUM","flagImgContent":"contcatus_flagImgContent__tFdRF","inputsearch":"contcatus_inputsearch__hRM00","all_offices":"contcatus_all_offices__BpLP1","viewMoreOffice":"contcatus_viewMoreOffice__xUR6_","card":"contcatus_card__YvE7h","contcatMainCard":"contcatus_contcatMainCard__0y9I5","contactCard":"contcatus_contactCard__EEQ82","icon":"contcatus_icon__nbjsA","arrowClass":"contcatus_arrowClass__btWWL","arrow":"contcatus_arrow__V_JKE","contactTabs":"contcatus_contactTabs__NJb9o","officesContainer":"contcatus_officesContainer__eaf3w","regionalManagers":"contcatus_regionalManagers__NPpJm","regionalSalesManagers":"contcatus_regionalSalesManagers__gicPI","card-title":"contcatus_card-title__hwfmv","regionaManagerSlider":"contcatus_regionaManagerSlider__cbeZl","salesManagerSlider":"contcatus_salesManagerSlider__ZAqJv","sliderCardDiv":"contcatus_sliderCardDiv__uHOTh","regiManagerImg":"contcatus_regiManagerImg__IlB9d","title":"contcatus_title__q4SKL","designation":"contcatus_designation__NBWFm","subtitle":"contcatus_subtitle__H35jp","text":"contcatus_text__toNdG","sliderDots":"contcatus_sliderDots__hUIsQ","regionalManVedio":"contcatus_regionalManVedio__7aY13","mangerVideo":"contcatus_mangerVideo__9v6ZR","officeAddress":"contcatus_officeAddress__oP9Tj","showMap":"contcatus_showMap__4H0EV","contactDetail":"contcatus_contactDetail__KwdFM","addDisplay":"contcatus_addDisplay__jNehd","content":"contcatus_content__ihu3P","para":"contcatus_para__RsU5c","addImg":"contcatus_addImg__u4ICx","map":"contcatus_map__CCyDg","viewMore":"contcatus_viewMore__egXfy","mobileAnchor":"contcatus_mobileAnchor__n2v3O","officeCountries":"contcatus_officeCountries__9zLZL"};

/***/ }),

/***/ 83157:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"countryadmissionsday_banner__kiMij","nav":"countryadmissionsday_nav__Stoca","navLogo":"countryadmissionsday_navLogo__9pU_M","maincontent":"countryadmissionsday_maincontent__EWEY_","fairdetails":"countryadmissionsday_fairdetails__Q9kXE","heading":"countryadmissionsday_heading__oUjWt","ulli":"countryadmissionsday_ulli__Mhf1j","regBtn":"countryadmissionsday_regBtn__Vf3yK","btnReg":"countryadmissionsday_btnReg__iT8q7","bannerStudDiv":"countryadmissionsday_bannerStudDiv__EQIjZ","bg":"countryadmissionsday_bg__RN8Zt","benefitsAttend":"countryadmissionsday_benefitsAttend__bvSoj","maindiv":"countryadmissionsday_maindiv__6v1if","mainBox":"countryadmissionsday_mainBox__Wl52Z","box":"countryadmissionsday_box__8dxaS","img":"countryadmissionsday_img__dv_xO","popularcourses":"countryadmissionsday_popularcourses__jyhHM","card":"countryadmissionsday_card__u19D_","cardImgDiv":"countryadmissionsday_cardImgDiv__CvCb0","cardImg":"countryadmissionsday_cardImg__rxXNr","cardBody":"countryadmissionsday_cardBody__DqTNl","caption":"countryadmissionsday_caption__p1FL9","caption2":"countryadmissionsday_caption2__0ZZIA","sliderDots":"countryadmissionsday_sliderDots__YKBHs","studentSpecialOffer":"countryadmissionsday_studentSpecialOffer__MJVJT","stuImg":"countryadmissionsday_stuImg__AXevw","whystuImg":"countryadmissionsday_whystuImg__yYoGk","stuImgtext":"countryadmissionsday_stuImgtext__7RB1a","stuImgtextd":"countryadmissionsday_stuImgtextd__y1nZx","headingabout":"countryadmissionsday_headingabout__UoSJC","OffersContent":"countryadmissionsday_OffersContent___hKfL","ulItem":"countryadmissionsday_ulItem__yRlU7","liItem":"countryadmissionsday_liItem__PuSD8","anchor":"countryadmissionsday_anchor__4W9FQ","row":"countryadmissionsday_row__i9im3","ScholarshipStudent":"countryadmissionsday_ScholarshipStudent__IaBcj","schStImg":"countryadmissionsday_schStImg__ykGre","SchContent":"countryadmissionsday_SchContent__49H1Q","studyquas":"countryadmissionsday_studyquas__EmUX3","stuAccordion":"countryadmissionsday_stuAccordion__VbaZm","accordion-button":"countryadmissionsday_accordion-button__Rh70t","collapsed":"countryadmissionsday_collapsed__J8CFE","accoHead":"countryadmissionsday_accoHead__tddyE","arrowsClass":"countryadmissionsday_arrowsClass__5cP_b","btcircle":"countryadmissionsday_btcircle__TCk9W","studentFooter":"countryadmissionsday_studentFooter__3qaYy","session":"countryadmissionsday_session__aK7h9","popularCoursesbg":"countryadmissionsday_popularCoursesbg__DA_qC","popularCourseslider":"countryadmissionsday_popularCourseslider__H3E7V","studyServSection":"countryadmissionsday_studyServSection__VYBux","imgPosition":"countryadmissionsday_imgPosition__CGsRP","txtPosition":"countryadmissionsday_txtPosition__HgE3L","studyContent":"countryadmissionsday_studyContent__q6tUY","studyContentpink":"countryadmissionsday_studyContentpink__WPJBO","platformDivImg":"countryadmissionsday_platformDivImg__R7aEn","picRound":"countryadmissionsday_picRound__DpvDp","pica":"countryadmissionsday_pica__XFIO9","picb":"countryadmissionsday_picb__Zztdr","picc":"countryadmissionsday_picc__Phr1j","picd":"countryadmissionsday_picd__gNom0","ulliQuick":"countryadmissionsday_ulliQuick__7OfrH","ulliQuickli":"countryadmissionsday_ulliQuickli__Aiptw","quickImg":"countryadmissionsday_quickImg__Yb4B_"};

/***/ }),

/***/ 42547:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"pstlandingpage_banner__g_UPf","nav":"pstlandingpage_nav__QrKZh","navLogo":"pstlandingpage_navLogo__rYw7Z","maincontent":"pstlandingpage_maincontent__tcl1X","fairdetails":"pstlandingpage_fairdetails___3Awg","heading":"pstlandingpage_heading__CmSZI","ulli":"pstlandingpage_ulli__fqPBp","liItem":"pstlandingpage_liItem__kE_QJ","regBtn":"pstlandingpage_regBtn__SXSXv","reg":"pstlandingpage_reg__808jO","enq":"pstlandingpage_enq__YbXM2","btnReg":"pstlandingpage_btnReg__ifx_Y","bannerStudDiv":"pstlandingpage_bannerStudDiv__h0Iis","bg":"pstlandingpage_bg__EOIvU","WhyKc":"pstlandingpage_WhyKc__aTj1F","viewMore":"pstlandingpage_viewMore__57U7q","whyMb":"pstlandingpage_whyMb__E2tnD","bussiness":"pstlandingpage_bussiness__8M5jS","uni":"pstlandingpage_uni__iGGja","img":"pstlandingpage_img__zoQjU","logo":"pstlandingpage_logo__PhEVL","sliderdiv":"pstlandingpage_sliderdiv__WSqCW","capabilityBg":"pstlandingpage_capabilityBg__e8FfP","content":"pstlandingpage_content__Lr07i","subcontent":"pstlandingpage_subcontent__bduG9","imgRow":"pstlandingpage_imgRow__5PEei","steps":"pstlandingpage_steps__uo121","points":"pstlandingpage_points__Qc5ZJ","mainbox":"pstlandingpage_mainbox__2nHev","boximg":"pstlandingpage_boximg___iqhq","association":"pstlandingpage_association__KcsWN","custCard":"pstlandingpage_custCard__2dOTw","imgDiv":"pstlandingpage_imgDiv__zKq9h","cardBody":"pstlandingpage_cardBody__5VPch","mainDiv":"pstlandingpage_mainDiv__E_si7","div":"pstlandingpage_div__12NSx","footer":"pstlandingpage_footer__UMKA1","footerlogo":"pstlandingpage_footerlogo__r5ngN","activeClass":"pstlandingpage_activeClass__XLLQe","arrowsClass":"pstlandingpage_arrowsClass___Haw3","btcircle":"pstlandingpage_btcircle__Sy1vj","sliderDots":"pstlandingpage_sliderDots__f2brx","elanLoansComp":"pstlandingpage_elanLoansComp__Xu5qO","elanContent":"pstlandingpage_elanContent__a4FxP","elanSubheading":"pstlandingpage_elanSubheading__MZ9zo","slider":"pstlandingpage_slider__ux_j6","imageDiv":"pstlandingpage_imageDiv__zXYkn","countryName":"pstlandingpage_countryName__y5U_f","button":"pstlandingpage_button__Hj8FU","enquirebtn":"pstlandingpage_enquirebtn__HXtlR","achievements":"pstlandingpage_achievements__4uMWW","description":"pstlandingpage_description__9Po_q","containerDiv":"pstlandingpage_containerDiv__1iO_z","sliderContainer":"pstlandingpage_sliderContainer__BD5UY","achievementsDiv":"pstlandingpage_achievementsDiv__gDUMc","icon":"pstlandingpage_icon__6cN3s","studVideo":"pstlandingpage_studVideo__57n8X","videoDiv":"pstlandingpage_videoDiv__gcrFA","videos":"pstlandingpage_videos__mNRB3","faqComponent":"pstlandingpage_faqComponent__DG96z","box":"pstlandingpage_box__dSteF","stuAccordion":"pstlandingpage_stuAccordion__0Carb","accoHead":"pstlandingpage_accoHead__5gc_W","card":"pstlandingpage_card___j1YG","cardImgDiv":"pstlandingpage_cardImgDiv__ANALH","cardImg":"pstlandingpage_cardImg__n_32_","caption":"pstlandingpage_caption___TAdQ","caption2":"pstlandingpage_caption2__V6haF","localeButton":"pstlandingpage_localeButton__N8bhp","selectClass":"pstlandingpage_selectClass__l1KDY"};

/***/ })

}]);